<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="BatchRun replica"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreReplica/BatchRunReplica/BatchRunReplicaDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
                color="primary"
                size="20"
                @click="onNotion(item)"
            >
              mdi-alpha-n-box-outline
            </v-icon>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import BatchRunReplicaDetail from "@/components/CoreReplica/BatchRunReplica/BatchRunReplicaDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "BatchRunReplicaTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'BatchRunReplicaTable'},
    dtoDetailQuery: {default: 'BatchRunReplicaDetailQueryDTO'},
    detailStoreName: {default: 'BatchRunReplicaDetail'},
    dtoValidateCommand: {type: [String], default: 'BatchRunReplicaValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'BatchRunReplicaListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BatchRunReplicaActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    BatchRunReplicaDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'N', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, width: 450},
      {text: 'Order', value: 'order', sortable: true, filterable: true, divider: true, width: 70},
      {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'Delivery date', value: 'delivery_date', sortable: true, filterable: true, divider: true, type: 'date'},
      {text: 'Lot size SMD', value: 'lot_size_smd', sortable: true, filterable: true, divider: true},
      {text: 'Lot size THT', value: 'lot_size_tht', sortable: true, filterable: true, divider: true},
      {text: 'VK pro BG', value: 'board_price', sortable: true, filterable: true, divider: true},
      {text: 'Customer orders', value: 'customer_orders', sortable: true, filterable: true, divider: true, width: 350},
      {text: 'Product orders', value: 'product_orders', sortable: true, filterable: true, divider: true, width: 350},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>